import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { trackEvent } from "@/utils/analytics";

interface DailyPromoButtonProps {
  // Where it is shown, for analytics.
  from: string;
  // Called on a click, before the daily game opens.
  onClick?: () => void;
}

// The classic game's way in to Daily Service: a labelled rule that sets it
// apart from the button above, then a cream button. Takes its parent's width.
export const DailyPromoButton = ({ from, onClick }: DailyPromoButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box w="100%">
      <Box display="flex" alignItems="center" gap={4} my={7}>
        <Box flex={1} h="1px" backgroundColor="whiteAlpha.500" />
        <Text
          fontFamily="'Barlow', sans-serif"
          fontSize="14px"
          fontWeight={600}
          letterSpacing="1px"
          color="whiteAlpha.800"
        >
          {t("daily.promoSeparator")}
        </Text>
        <Box flex={1} h="1px" backgroundColor="whiteAlpha.500" />
      </Box>
      <Link
        to="/daily"
        onClick={() => {
          onClick?.();
          trackEvent("daily_promo_clicked", { from });
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={3}
          h="52px"
          borderRadius="6px"
          backgroundColor="#FBF6EC"
          color="#152238"
        >
          <Text
            fontFamily="'Barlow', sans-serif"
            fontSize="11px"
            fontWeight={700}
            letterSpacing="1.5px"
            textTransform="uppercase"
            color="#FBF6EC"
            backgroundColor="#B83A26"
            borderRadius="4px"
            px={2}
            py="2px"
          >
            {t("daily.promoNew")}
          </Text>
          <Text fontFamily="Airline" fontSize="20px" lineHeight={1}>
            Daily Service
          </Text>
        </Box>
      </Link>
    </Box>
  );
};
